import FinishReviewButton from './finish-review-button'

export default FinishReviewButton
